export class Microsoft365WholeUserRestore {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "users",
            "baseName": "users",
            "type": "Array<Microsoft365UserRestoreSelection>",
            "format": ""
        },
        {
            "name": "workloads",
            "baseName": "workloads",
            "type": "Array<Microsoft365RestoreWorkload>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return Microsoft365WholeUserRestore.attributeTypeMap;
    }
    constructor() {
    }
}
